import request from '@/utils/request'



export function orderInfoBatchDelete(data) {
    return request({
        url: `api/serviceCenter/orderInfo/orderInfoBatchDelete`,
        method: 'post',
        data,
    })
}


export function selectOrderInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/orderInfo/selectOrderInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })

}



export function updateOrderInfo(data) {
    return request({
        url: `api/serviceCenter/orderInfo/updateOrderInfo`,
        method: 'post',
        data,
    })
}




export function orderInfoInsertOne(data) {
    return request({
        url: `api/serviceCenter/orderInfo/orderInfoInsertOne`,
        method: 'post',
        data,
    })
}


export function productSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/product/productSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function selectAllCustomer(data) {
    return request({
        url: `api/serviceCenter/customer/selectAllCustomer?access=${data}`,
        method: 'post',
    })
}
export function selectAllUser(data) {
    return request({
        url: `api/serviceCenter/user/selectAllUser?access=${data}`,
        method: 'post',
    })
}
export function selectAllDistribution(data) {
    return request({
        url: `api/serviceCenter/distribution/selectAllDistribution?access=${data}`,
        method: 'post',
    })
}
export function selectAllCollection(data) {
    return request({
        url: `api/serviceCenter/collection/selectAllCollection?access=${data}`,
        method: 'post',
    })
}
export function selectProductCategory(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/product/selectProductCategory`,
        method: 'post',
        data,
    })
}


export function selectProduct(data) {
    return request({
        url: `api/serviceCenter/product/selectProduct?productId=${data}`,
        method: 'post',
    })
}

export function selectOrder(data) {
    return request({
        url: `api/serviceCenter/orderManagement/selectOrder?access=${data}`,
        method: 'post',
    })
}

export function sendingToManuscripts(data) {
    return request({
        url: `api/serviceCenter/orderInfo/sendingToManuscripts`,
        method: 'post',
        data,
    })
}
